import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_46: FaireProductEntity = {
  token: "catalog_prod_prod-46",
  type: "product",
  name: "Teak Root Sculpture on Stand",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1602874801007-bd458bb1b8b6?w=400&h=400&fit=crop",
  priceDollars: 30.76,
  msrpDollars: 76.9,
  sku: "JA0046",
  caseSize: 3,
  material: "Metal",
  collectionToken: "col_japandi",
  categoryTokens: ["catalog_cat_cats"],
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: true,
  inStock: true,
  stockLevel: 104,
  description: "Beautiful Japandi piece perfect for any home.",
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
